/*  Most of this file does not need to be touched unless you need to pass additional parameters into the store on an action.*/
/*  Simply edit the model variable below for each model name before saving */
/*  Reducers need to be imported into the reducers.js file within the /store folder */

const model = 'PAYMENT';

const initialState = {
  loading: false,
  success: false,
  error: null,
  list: [],
  entry: {},
};

/* --------------------- ACTIONS ----------------------- */

export const fetchAllStart = () => ({
  type: model + '_FETCH_ALL_START',
});

export const fetchAllSuccess = data => ({
  type: model + '_FETCH_ALL_SUCCESS',
  data,
});

export const fetchAllError = error => ({
  type: model + '_FETCH_ALL_ERROR',
  error,
});

export const fetchStart = () => ({
  type: model + '_FETCH_START',
});

export const fetchSuccess = data => ({
  type: model + '_FETCH_SUCCESS',
  data,
});

export const fetchError = error => ({
  type: model + '_FETCH_ERROR',
  error,
});

export const createStart = () => ({
  type: model + '_CREATE_START',
});

export const createSuccess = data => ({
  type: model + '_CREATE_SUCCESS',
  data,
});

export const createError = error => ({
  type: model + '_CREATE_ERROR',
  error,
});

export const updateStart = () => ({
  type: model + '_UPDATE_START',
});

export const updateSuccess = data => ({
  type: model + '_UPDATE_SUCCESS',
  data,
});

export const updateError = error => ({
  type: model + '_UPDATE_ERROR',
  error,
});

export const deleteStart = () => ({
  type: model + '_DELETE_START',
});

export const deleteSuccess = data => ({
  type: model + '_DELETE_SUCCESS',
  data,
});

export const deleteError = error => ({
  type: model + '_DELETE_ERROR',
  error,
});

/* --------------------- REDUCERS ----------------------- */

export const reducers = (state = initialState, action) => {
  switch (action.type) {
    case model + '_FETCH_ALL_START':
      state = Object.assign({}, state, {
        loading: true,
      });
      return state;
    case model + '_FETCH_ALL_SUCCESS':
      state = Object.assign({}, state, {
        loading: false,
        success: true,
        list: action.data,
      });
      return state;
    case model + '_FETCH_ALL_ERROR':
      state = Object.assign({}, state, {
        loading: false,
        success: false,
        error: action.error,
      });
      return state;
    case model + '_FETCH_START':
      state = Object.assign({}, state, {
        loading: true,
      });
      return state;
    case model + '_FETCH_SUCCESS':
      state = Object.assign({}, state, {
        loading: false,
        success: true,
        entry: action.data,
      });
      return state;
    case model + '_FETCH_ERROR':
      state = Object.assign({}, state, {
        loading: false,
        success: false,
        error: action.error,
      });
      return state;
    case model + '_CREATE_START':
      state = Object.assign({}, state, {
        loading: true,
      });
      return state;
    case model + '_CREATE_SUCCESS':
      state = Object.assign({}, state, {
        loading: false,
        success: true,
        entry: action.data,
      });
      return state;
    case model + '_CREATE_ERROR':
      state = Object.assign({}, state, {
        loading: false,
        success: false,
        error: action.error,
      });
      return state;
    case model + '_UPDATE_START':
      state = Object.assign({}, state, {
        loading: true,
      });
      return state;
    case model + '_UPDATE_SUCCESS':
      state = Object.assign({}, state, {
        loading: false,
        success: true,
        entry: action.data,
      });
      return state;
    case model + '_UPDATE_ERROR':
      state = Object.assign({}, state, {
        loading: false,
        success: false,
        error: action.error,
      });
      return state;
    case model + '_DELETE_START':
      state = Object.assign({}, state, {
        loading: true,
      });
      return state;
    case model + '_DELETE_SUCCESS':
      state = Object.assign({}, state, {
        loading: false,
        success: true,
        entry: null,
      });
      return state;
    case model + '_DELETE_ERROR':
      state = Object.assign({}, state, {
        loading: false,
        success: false,
        error: action.error,
      });
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/payments/actions.js